import {fetchJSON} from '../../platform/functional-fetch-wrapper'

export interface AgentModel {
  id: string
  name: string
  vendor: string
}

export interface GetAgentModelsResponse {
  models: Array<AgentModel>
}

/**
 * Fetches available Copilot coding agent models for a given repository.
 * The endpoint is at `/:owner/:repo/copilot/coding_agent/models`.
 *
 * Note: This endpoint is repository-scoped (not a memex API route), so there is no
 * server-rendered memex API metadata available via `getApiMetadata`. We construct the
 * URL directly from the repo name with owner.
 */
export async function apiGetAgentModels(repoNameWithOwner: string): Promise<GetAgentModelsResponse> {
  const url = new URL(`/${repoNameWithOwner}/copilot/coding_agent/models`, window.location.origin)
  const {data} = await fetchJSON<GetAgentModelsResponse>(url)
  return data
}
